import history from "./history";
import moment from "moment";
import { DECLINED, PENDING, routesCommon, VISIT_COMPLETED } from "../constants";
import sortBy from "lodash/sortBy";
import groupBy from "lodash/groupBy";
import { TYPES_CHIPS } from "../components/Common/Chip/constants";

let globalLoadingCount = 0;

export const isLoading = (show) => {
  try {
    const loader =
      document.getElementById("global-page-loader") ||
      document.querySelector(".loader-page-all-requests");
    if (show) {
      globalLoadingCount += 1;
      loader?.classList.add("loader-page-all-requests_show");
    } else {
      globalLoadingCount = Math.max(0, globalLoadingCount - 1);
      if (globalLoadingCount === 0) {
        loader?.classList?.remove("loader-page-all-requests_show");
      }
    }
  } catch (error) {
    globalLoadingCount = 0;
    window.localStorage.removeItem("requests");
  }
};

import { endSession } from "./session";

export const clearAuthSession = () => {
  endSession({ clearTokens: true });
};

export const getPortalFromPath = (pathname = history.location?.pathname) => {
  const segments = (pathname || "").split("/");
  if (segments.includes("admin")) return "admin";
  if (segments.includes("doctor")) return "doctor";
  if (segments.includes("patient")) return "patient";
  return null;
};

export const redirectUnauthenticated = (portal) => {
  const target = portal || getPortalFromPath();
  clearAuthSession();
  if (target) {
    window.location.replace(`${routesCommon.login_form}/${target}`);
    return;
  }
  window.location.replace(routesCommon.landing);
};

export const formatReceipt = (arr) => {
  const diagnosis = [];
  const services = [];
  if (Array.isArray(arr)) {
    arr.forEach((i) => {
      if (i.diagnosis) {
        diagnosis.push(i);
      } else {
        services.push(i);
      }
    });
  }
  return [...diagnosis, ...services];
};

export const dateToDisplay = (applicationTime) => {
  if (!applicationTime) {
    return moment().format("ll");
  }
  return moment(moment(applicationTime).format("YYYY-MM-DD")).isSame(
    moment().format("YYYY-MM-DD"),
  )
    ? "Today"
    : moment(applicationTime).format("ll");
};

export const dateForMultiple = (timeStart, timeEnd) => {
  const applicationStartTime = moment(timeStart).format("MMM DD, hh:mm A");
  const applicationEndTime = moment(timeEnd).format("hh:mm A");
  return `${applicationStartTime} – ${applicationEndTime}`;
};

export const groupPatientsByRelation = (patients) => {
  let groupedPatients = sortBy(patients, "status");
  groupedPatients = groupBy(groupedPatients, "client_patient_relationship");
  groupedPatients = Object.keys(groupedPatients).map((i) => ({
    label: i,
    items: groupedPatients[i],
  }));
  groupedPatients = sortBy(
    groupedPatients,
    (obj) => obj.label !== "null" && obj.label,
  );
  return groupedPatients;
};

export const defineChipType = (status) => {
  const statusToLower = status.toLowerCase();
  if (statusToLower === DECLINED) {
    return TYPES_CHIPS.DECLINED;
  } else if (statusToLower === PENDING) {
    return TYPES_CHIPS.PENDING;
  } else if (statusToLower === VISIT_COMPLETED) {
    return TYPES_CHIPS.VISIT_COMPLETED;
  } else {
    return TYPES_CHIPS.PRIMARY;
  }
};
